import { atomWithStorage } from "jotai/utils";

const holidayHoursAtom = atomWithStorage("meucontroleai:holiday-hours", false)

export default holidayHoursAtom
